/* eslint camelcase: 0 */
import { Admission, AdmissionRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { IAdmissionProps, EmptyAdmissionPropsFactory } from '@/entities/Admission'

export const toAdmissionProps = (props: Admission | null | undefined): IAdmissionProps => {
  if (!props) {
    return EmptyAdmissionPropsFactory()
  }

  const {
    id,
    hospital_id,
    user_id,
    area_id,
    user,
    hospital,
    area,
    staytime,
    properties,
    started_at,
    is_appointment,
    has_result,
    checkin_at,
    checkout_at,
    created_at,
    updated_at
  } = props

  return EmptyAdmissionPropsFactory({
    id,
    hospitalId: hospital_id,
    userId: user_id,
    areaId: area_id,
    user,
    hospital,
    area,
    staytime,
    properties,
    startedAt: started_at,
    isAppointment: is_appointment,
    hasResult: has_result,
    checkinAt: checkin_at,
    checkoutAt: checkout_at,
    createdAt: created_at,
    updatedAt: updated_at
  })
}

export const toAdmissionRequest = (props: IAdmissionProps): AdmissionRequest => {
  const { areaId, checkinAt, checkoutAt, properties } = props
  return {
    area_id: areaId!,
    checkin_at: checkinAt!,
    checkout_at: checkoutAt!,
    properties: properties!
  }
}
